import React from "react";
import { Button, Popconfirm, Space } from "antd";
import { PlayCircleOutlined, StopOutlined } from "@ant-design/icons";
import { useLicensesActions, useLicensesState } from "src/reducers/subscription";
import { useLanguage } from "src/providers/LanguageProvider";

const SubscriptionDrawerLicenseActions: React.FC = () => {
  const { t } = useLanguage();
  const { selected } = useLicensesState();
  const { cancelMainLicense } = useLicensesActions();

  if (!selected) return null;

  const handleCancel = async () => {
    await cancelMainLicense(selected.Id);
  };

  return (
    <Space wrap>
      <Popconfirm
        title={t("CONFIRM_CANCEL_TITLE")}
        description={t("CONFIRM_CANCEL_DESC")}
        onConfirm={handleCancel}
        okText={t("YES")}
        cancelText={t("NO")}
      >
        <Button danger icon={<StopOutlined />}>
          {t("BTN_CANCEL_SUBSCRIPTION")}
        </Button>
      </Popconfirm>

      <Button
        type="primary"
        icon={<PlayCircleOutlined />}
        disabled={!selected.configureUrl}
        onClick={() => {
          if (selected.configureUrl) window.location.href = selected.configureUrl;
        }}
      >
        {t("BTN_MANAGE")}
      </Button>
    </Space>
  );
};

export default SubscriptionDrawerLicenseActions;
